import Native from './native';
import Hls from './hls';
import Iframe from './iframe';

export default [
  Hls,
  Iframe,
  Native,
];
